var _path, _rect, _circle, _circle2, _circle3, _rect2, _rect3, _path2, _circle4, _circle5, _circle6, _circle7, _rect4, _rect5, _g, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g2, _rect12, _rect13, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTip7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 399,
    viewBox: "0 0 494 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 0H467C481.912 0 494 12.0883 494 27V372C494 386.912 481.912 399 467 399H115C100.641 399 89 387.359 89 373V0Z",
    fill: "#D2FFCE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 177.05,
    width: 91,
    height: 86,
    rx: 10.5,
    transform: "rotate(-44.9964 0.707107 177.05)",
    fill: "#7FEF76",
    stroke: "#51D346"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 323,
    r: 63,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 323,
    r: 44,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.5,
    cy: 107.5,
    r: 35.5,
    stroke: "#E1D4E8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_40)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_40)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 114,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 150.5,
    width: 68,
    height: 64,
    rx: 10.5,
    stroke: "#51D346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.461 187.081H167.031L163.923 194H161.074L172.914 168.1H175.615L187.455 194H184.569L181.461 187.081ZM180.462 184.861L174.246 170.949L168.03 184.861H180.462ZM197.992 174.39C200.533 174.39 202.482 175.031 203.838 176.314C205.195 177.572 205.873 179.447 205.873 181.938V194H203.357V190.966C202.765 191.977 201.89 192.767 200.73 193.334C199.596 193.901 198.239 194.185 196.66 194.185C194.49 194.185 192.763 193.667 191.48 192.631C190.198 191.595 189.556 190.226 189.556 188.524C189.556 186.871 190.148 185.539 191.332 184.528C192.541 183.517 194.453 183.011 197.067 183.011H203.246V181.827C203.246 180.15 202.778 178.879 201.84 178.016C200.903 177.128 199.534 176.684 197.733 176.684C196.5 176.684 195.316 176.894 194.181 177.313C193.047 177.708 192.072 178.263 191.258 178.978L190.074 177.017C191.061 176.178 192.245 175.537 193.626 175.093C195.008 174.624 196.463 174.39 197.992 174.39ZM197.067 192.113C198.547 192.113 199.818 191.78 200.878 191.114C201.939 190.423 202.728 189.437 203.246 188.154V184.972H197.141C193.811 184.972 192.146 186.131 192.146 188.45C192.146 189.585 192.578 190.485 193.441 191.151C194.305 191.792 195.513 192.113 197.067 192.113Z",
    fill: "#2C2C2C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 153.5,
    r: 3.5,
    fill: "#51D346"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.5,
    cy: 153.5,
    r: 3.5,
    fill: "#51D346"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.5,
    cy: 211.5,
    r: 3.5,
    fill: "#51D346"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 211.5,
    r: 3.5,
    fill: "#51D346"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 157,
    width: 122,
    height: 61,
    rx: 8,
    fill: "url(#paint0_linear_1_40)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_40",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 281,
    y: 157,
    width: 122,
    height: 61
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 157,
    width: 122,
    height: 61,
    rx: 8,
    fill: "url(#paint1_linear_1_40)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.552 169.883L281.598 199.429C281.215 199.795 280.993 200.297 280.979 200.826L280.551 217.974C280.523 219.089 281.412 220.011 282.526 220.024L404.508 221.47C405.787 221.486 406.752 220.313 406.489 219.061L402.682 200.867C402.566 200.315 402.222 199.837 401.735 199.552L374.503 183.588C373.883 183.224 373.116 183.222 372.493 183.58L345.362 199.215C344.563 199.676 343.552 199.53 342.916 198.861L315.381 169.95C314.618 169.149 313.351 169.119 312.552 169.883Z",
    fill: "url(#paint2_linear_1_40)"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 232,
    width: 122,
    height: 13,
    rx: 6.5,
    fill: "#A3EBFB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 252,
    width: 257,
    height: 13,
    rx: 6.5,
    fill: "#A3EBFB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 272,
    width: 257,
    height: 13,
    rx: 6.5,
    fill: "#A3EBFB"
  })))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8065,
    y: 153.258,
    width: 76.8173,
    height: 72.5881,
    rx: 10.5,
    transform: "rotate(-19.93 40.8065 153.258)",
    stroke: "#51D346"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 297.05,
    y: 83,
    width: 110.878,
    height: 55.4392,
    rx: 8,
    transform: "rotate(6.32342 297.05 83)",
    fill: "url(#paint3_linear_1_40)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_40",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: 83,
    width: 116,
    height: 67
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 297.05,
    y: 83,
    width: 110.878,
    height: 55.4392,
    rx: 8,
    transform: "rotate(6.32342 297.05 83)",
    fill: "url(#paint4_linear_1_40)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.116 97.906L293.403 121.341C292.982 121.662 292.706 122.137 292.634 122.661L290.566 137.851C290.415 138.955 291.197 139.97 292.304 140.106L401.937 153.572C403.207 153.728 404.295 152.669 404.172 151.396L402.583 134.887C402.529 134.325 402.24 133.812 401.788 133.475L378.936 116.44C378.36 116.011 377.597 115.923 376.939 116.211L351.095 127.518C350.25 127.888 349.261 127.632 348.702 126.897L326.921 98.2846C326.251 97.405 324.995 97.2354 324.116 97.906Z",
    fill: "url(#paint5_linear_1_40)"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 330.614,
    y: 7.93866,
    width: 101.884,
    height: 50.9418,
    rx: 8,
    transform: "rotate(19.0689 330.614 7.93866)",
    fill: "url(#paint6_linear_1_40)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_40",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 316,
    y: 10,
    width: 109,
    height: 78
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 330.614,
    y: 7.93866,
    width: 101.884,
    height: 50.9418,
    rx: 8,
    transform: "rotate(19.0689 330.614 7.93866)",
    fill: "url(#paint7_linear_1_40)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.702 26.8526L319.633 41.5341C319.152 41.7544 318.778 42.1564 318.593 42.6521L313.74 55.6293C313.35 56.6735 313.889 57.8354 314.938 58.2121L410.121 92.383C411.324 92.8152 412.619 92.0218 412.78 90.753L414.668 75.9068C414.74 75.3469 414.571 74.783 414.204 74.3542L397.285 54.5808C396.818 54.0347 396.093 53.7813 395.388 53.917L370.151 58.7698C369.245 58.944 368.337 58.4757 367.954 57.6362L354.354 27.8406C353.895 26.835 352.707 26.3925 351.702 26.8526Z",
    fill: "url(#paint8_linear_1_40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.702 26.8526L319.633 41.534C319.152 41.7543 318.778 42.1564 318.593 42.6521L313.74 55.6292C313.35 56.6734 313.889 57.8353 314.938 58.212L410.121 92.383C411.324 92.8151 412.619 92.0218 412.78 90.7529L414.668 75.9067C414.74 75.3469 414.571 74.783 414.204 74.3542L397.285 54.5807C396.818 54.0347 396.093 53.7813 395.388 53.917L370.151 58.7697C369.245 58.944 368.337 58.4756 367.954 57.6362L354.354 27.8406C353.895 26.8349 352.707 26.3924 351.702 26.8526Z",
    fill: "url(#paint9_linear_1_40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.144 31.2032L340.597 31.8651L353.758 25.9563L358.529 36.4044L358.053 38.238L355.082 35.0492L349.62 38.3515L345.144 31.2032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_40",
    x: 86,
    y: 94,
    width: 397,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_40"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_40",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_40",
    x1: 342,
    y1: 157,
    x2: 342,
    y2: 221.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3EBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_40",
    x1: 342,
    y1: 157,
    x2: 342,
    y2: 220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EBFB",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_40",
    x1: 344,
    y1: 193,
    x2: 344,
    y2: 266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ADE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD677",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_40",
    x1: 352.49,
    y1: 83,
    x2: 352.49,
    y2: 122.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#679BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA26D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_40",
    x1: 352.49,
    y1: 83,
    x2: 352.49,
    y2: 140.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_40",
    x1: 350.355,
    y1: 121.826,
    x2: 347.552,
    y2: 147.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2476C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ADCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_40",
    x1: 381.556,
    y1: 7.93866,
    x2: 381.556,
    y2: 43.8485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A167FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_40",
    x1: 381.556,
    y1: 7.93866,
    x2: 381.556,
    y2: 60.5507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_40",
    x1: 370.517,
    y1: 53.5417,
    x2: 362.877,
    y2: 75.6417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2476C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_40",
    x1: 370.517,
    y1: 53.5417,
    x2: 362.877,
    y2: 75.6417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6024C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 114,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip7);
export default __webpack_public_path__ + "static/media/tip7.00a20dcb7916c8109a30fdbdec7834e5.svg";
export { ForwardRef as ReactComponent };